import React from "react";
import { useEffect } from "react";
import MaterialTable from "material-table";
import {
  Box,
  Chip,
  CircularProgress,
  FormControl,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  ConvertDate,
  ConvertDateTime,
  getUserId,
} from "../../../../Base/helper/baseFunctions";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { GetLeaveTypeAction } from "../../../../../../store/Leave/LeaveType/Action";
import SelectableSearch from "../../../../Base/views/SelectableSearch";
import { getUserData } from "../../../../Base/helper/baseFunctions";
import { TimeOffBookingsHelper } from "../../../helper/TimeOff/TimeOffHelper";
import footerlogoSrc from "../../../image/Meepl_new_logo with text png.png"
import jsPDF from "jspdf";
import "jspdf-autotable";
import GetAppIcon from "@mui/icons-material/GetApp";

const TeamTimeOffBookings = ({ flag }) => {
  const empData = getUserData();
  const dispatch = useDispatch();
  const [data, setData] = useState({
    leavetype_id: { leavetype_id: 0, name: "All" },
  });
  const [leaveTypeOptions, setLeaveTypeOptions] = useState({
    load: true,
    values: [],
  });
  const [leaveStatus, setLeaveStatus] = useState({ load: true, values: [] });

  const { leavetypes_options } = useSelector(
    (state) => state.LeaveReducer.LeaveTypeReducer
  );
  const [leaveReportData, setLeaveReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);

  useEffect(() => {
    dispatch(GetLeaveTypeAction());
    setLeaveStatus({
      load: false,
      values: [
        {
          id: "1",
          name: "Submitted",
        },
        {
          id: "2",
          name: "Approved",
        },
        {
          id: "3",
          name: "Rejected",
        },
        {
          id: "4",
          name: "Cancelled",
        },
      ],
    });
  }, [dispatch]);

  const handleLeaveTypeOptions = () => {
    leavetypes_options?.splice(0, 0, { leavetype_id: 0, name: "All" });
    if (empData?.gender === "Female") {
      setLeaveTypeOptions({
        load: false,
        values: leavetypes_options.filter(
          (lt) => lt.name !== "Paternity Leave"
        ),
      });
    } else if (empData?.gender === "Male") {
      setLeaveTypeOptions({
        load: false,
        values: leavetypes_options.filter(
          (lt) => lt.name !== "Maternity Leave"
        ),
      });
    } else {
      setLeaveTypeOptions({ load: false, values: leavetypes_options });
    }
  };

  const handleChange = (event, value) => {
    setData({ ...data, [event]: value });
  };

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleExportPDF = () => {
      setMenuAnchor(null); 
      setLoading(true); 

      setTimeout(() => {
        const doc = new jsPDF({ compress: true }); 
        doc.text("Leave Reports", 14, 10);

        const tableHeaders = [["Name", "Leave Type", "Start Date", "End Date", "Duration", "Status", "Last Updated"]];
        const tableBody = leaveReportData.map((row) => [
          row.employee,
          row.leavetype,
          ConvertDate(row.start_date),
          ConvertDate(row.end_date),
          row.effective_days,
          row.request_status,
          ConvertDateTime(row.submitted_on),
        ]);

      doc.autoTable({
        head: tableHeaders,
        body: tableBody,
          didDrawPage: (data) => {
          const pageWidth = doc.internal.pageSize.width;
          const pageHeight = doc.internal.pageSize.height;
          const footerY = pageHeight - 20;

          const imgWidth = 30;
          const imgHeight = 10;
          const text = "Powered by";
          const gap = 5;

          doc.setFontSize(10);
          const textWidth = doc.getTextWidth(text);
          const totalWidth = textWidth + gap + imgWidth;
          const startX = (pageWidth - totalWidth) / 2;

          const centerY = footerY + imgHeight / 2;
          doc.text(text, startX, centerY, {
            baseline: "middle",
          });

      doc.addImage(footerlogoSrc, "PNG", startX + textWidth + gap, footerY, imgWidth, imgHeight);
  }
      });
          doc.save("Leave_Reports.pdf");
          setLoading(false); 
        }, 0);

  };
  const handleExportCSV = () => {
        handleMenuClose();
        setLoading(true);

        try {
          const headers = [
            { label: "Name", key: "employee" },
            { label: "Leave Type", key: "leavetype" },
            { label: "Start Date", key: "start_date", formatter: ConvertDate },
            { label: "End Date", key: "end_date", formatter: ConvertDate },
            { label: "Duration", key: "effective_days" },
            { label: "Status", key: "request_status" },
            { label: "Last Updated", key: "submitted_on", formatter: ConvertDateTime },
          ];
          const csvData = [headers.map(header => header.label)];
          leaveReportData?.forEach(row => {
            const rowData = headers.map(header => {
              const value = row[header.key];
              return header.formatter ? header.formatter(value) : value;
            });
            csvData.push(rowData);
          });

          const csv = csvData.map(row => row.join(",")).join("\n");
          const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
          const url = URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = "Leave_Reports.csv";
          downloadLink.setAttribute("target", "_blank");
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(url);
        } catch (error) {
          console.error("CSV Export Failed:", error);
        } finally {
          setLoading(false);
        }
  };


  useEffect(() => {
    TimeOffBookingsHelper({ ...data, my_time_flag: true, emp_user_id: getUserId()}).then((res) => {
      if (res?.data?.statuscode === 200) {
        setLeaveReportData(res?.data?.data);
      }
    });
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, flag]);

  return (
    <>
      <>
        <Box
          sx={{
            py: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <FormControl fullWidth sx={{ padding: "5px", pr: 3 }}>
            <SelectableSearch
              label="Leave Type"
              value={data?.leavetype_id}
              loading={() => handleLeaveTypeOptions()}
              fieldLabel="name"
              autoFocus={false}
              required={false}
              variant={"outlined"}
              name="leavetype_id"
              size="small"
              onChangeEvent={handleChange}
              data={leaveTypeOptions}
            />
          </FormControl>
          <FormControl fullWidth sx={{ padding: "5px", pr: 2, pl: 3 }}>
            <SelectableSearch
              label="Leave Status"
              value={leaveStatus?.id}
              loading={() => {}}
              fieldLabel="name"
              autoFocus={false}
              variant={"outlined"}
              name="status"
              size="small"
              onChangeEvent={handleChange}
              data={leaveStatus}
            />
          </FormControl>
        </Box>
        <MaterialTable
          columns={[
            {
              title: "Name",
              field: "employee",
              cellStyle: { padding: "5px 10px" },
            },
            {
              title: "Leave Type",
              field: "leavetype",
              cellStyle: { padding: "5px 10px" },
              render: (rowData) => renderLeaveTypeCell(rowData),
            },
            {
              title: "Start Date",
              field: "start_date",
              cellStyle: { padding: "5px 10px" },
              render: (rowData) => {
                return ConvertDate(rowData.start_date);
              },
            },
            {
              title: "End Date",
              field: "end_date",
              cellStyle: { padding: "5px 10px" },
              render: (rowData) => {
                return ConvertDate(rowData.end_date);
              },
            },
            {
              title: "Duration",
              field: "effective_days",
              cellStyle: { padding: "5px 10px 5px 30px" },
            },
            {
              title: "Status",
              field: "request_status",
              cellStyle: { padding: "5px 5px" },
              render: (rowData) => {
                return rowData.request_status === "Approved" ? (
                  <Chip
                    label="Approved"
                    color="success"
                    size="small"
                    variant="outlined"
                  />
                ) : rowData.request_status === "Submitted" ? (
                  <Chip
                    label="Submitted"
                    color="info"
                    size="small"
                    variant="outlined"
                  />
                ) : rowData.request_status === "Rejected" ? (
                  <Chip
                    label="Rejected"
                    color="warning"
                    size="small"
                    variant="outlined"
                  />
                ) : rowData.request_status === "Cancel Requested" ? (
                  <Chip
                    title="Cancel Requested"
                    label="Cancel Requested"
                    size="small"
                    variant="outlined"
                    sx={{
                      width: "120px",
                      color: "#ffb400",
                      borderColor: "#ffb400",
                    }}
                  />
                ) : rowData.request_status === "Cancelled" ? (
                  <Chip
                    label="Cancelled"
                    color="error"
                    size="small"
                    variant="outlined"
                  />
                ) : (
                  <p style={{ color: "#B0B700", fontWeight: "bold" }}>
                    {rowData.request_status}
                  </p>
                );
              },
            },
            {
              title: "Last Updated",
              field: "submitted_on",
              cellStyle: { padding: "5px 15px" },
              render: (rowData) => {
                return ConvertDateTime(rowData.submitted_on);
              },
            },
          ]}
          data={leaveReportData}
          options={{
            maxBodyHeight: 230,
            rowStyle: { fontSize: "13px" },
            headerStyle: { padding: "0px 15px", fontWeight: "bold" },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: true,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [10, 25],
            pageSize: 10,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: true,
            exportFileName: "Leave Reports",
            addRowPosition: "first",
            selection: false,
            showSelectAllCheckbox: true,
            showTextRowsSelected: true,
            grouping: false,
            columnsButton: true,
          }}
          actions={[
            {
            icon: () => (
                <IconButton
                   sx={{
                    boxShadow: "none",
                    "&:hover": {
                      boxShadow: "none", 
                      backgroundColor: "transparent", 
                    },
                  }}
                >
                  {loading ? 
                   <CircularProgress color="inherit" size={24} disableShrink />
             : <GetAppIcon />}
                </IconButton>
            ),
            tooltip: "Export",
            isFreeAction: true,
            onClick: (event) => handleMenuOpen(event),
            hidden: leaveReportData?.length === 0,
        },
        
      ]}
          title={"Bookings"}
        />
        <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleExportCSV}>Export as CSV</MenuItem>
            <MenuItem onClick={handleExportPDF}>Export as PDF</MenuItem>

        </Menu>
      </>
    </>
  );
};

  const renderLeaveTypeCell = (rowData) => {
    const leaveLabel = rowData?.leavetype || "";
    if (leaveLabel !== "Compensatory Off") {
      return leaveLabel;
    }

    let mapping = null;
    if (rowData?.compoff_date_mapping_json) {
      try {
        mapping = typeof rowData.compoff_date_mapping_json === "string"
          ? JSON.parse(rowData.compoff_date_mapping_json)
          : rowData.compoff_date_mapping_json;
      } catch (e) {
        console.error("Error parsing compoff_date_mapping_json:", e);
      }
    }

    const tooltipContent = mapping && Object.keys(mapping).length > 0 ? (
      <Box sx={{ p: 0.5 }}>
        {Object.entries(mapping).map(([leaveDate, workedDate]) => {
          return (
            <Typography key={leaveDate} variant="caption" display="block" sx={{ fontSize: "11px", whiteSpace: "nowrap" }}>
              Leave Date: {ConvertDate(leaveDate)} (Comp-Off Earned On: {ConvertDate(workedDate)})
            </Typography>
          );
        })}
      </Box>
    ) : (
      "No Comp-Off Earned On dates mapped."
    );

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'inherit' }}>
        <Typography sx={{color: "inherit"}}>{leaveLabel}</Typography>
        <Tooltip
          title={tooltipContent}
          placement="bottom"
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: "none",
              }
            }
          }}
        >
          <InfoOutlinedIcon
            color="action"
            style={{ cursor: "pointer", fontSize: "16px" }}
          />
        </Tooltip>
      </Box>
    );
  };

export default TeamTimeOffBookings;
